// extracted by mini-css-extract-plugin
export default {"root":"Header_root__KkSbk","logo":"Header_logo__UsziS","transparent":"Header_transparent__fcGs-"};